import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import * as _ from 'underscore';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { Omit } from '../../../ts/helpers/TypescriptHelpers';
import { AuthLevel, ServerService } from '../../../ts/services/ServerService';
import { ServiceLocator } from '../../ServiceLocator';
import { SiteTasksSubspaceName } from '../../state/SpaceInfo';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { SiteTasksSpaceProvider, SiteTasksSpaceProviderProps } from './SiteTasksSpaceProvider';

export interface SiteTasksSpaceRouteParams {}

export interface SiteTasksRouteComponentProps extends RouteComponentProps<SiteTasksSpaceRouteParams> {}

export interface SiteTasksSpaceRouterOwnProps extends ReactDirectiveProps {
  readonly urls: SpacesSiteUrls;
  readonly provider: (subspaceName: SiteTasksSubspaceName, providerProps: SiteTasksSpaceComponentWithRouterProps) => (props: SiteTasksRouteComponentProps) => JSX.Element;
}

export type SiteTasksSpaceRouterProps = SiteTasksSpaceRouterOwnProps;

export class SiteTasksSpaceRouterComponent extends React.Component<SiteTasksSpaceRouterProps> {
  private server: ServerService;

  public constructor(props: SiteTasksSpaceRouterProps) {
    super(props);
    this.server = ServiceLocator.get<ServerService>('ServerService');
  }

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.tasksExtractRefreshesPath()} render={this.props.provider('extractRefreshes', this.props)}/>
        <Route exact path={this.props.urls.tasksFlowsPath()} render={this.props.provider('runFlowTasks', this.props)}/>
        <Route exact path={this.props.urls.tasksSubscriptionsPath()} render={this.props.provider('subscriptions', this.props)}/>

        {/* {this.protectedRouteForExtractRefreshSubspace(this.server)} */}

        <Route exact path={this.props.urls.tasksPath()} render={() => (
          <Redirect to={this.props.urls.tasksExtractRefreshesPath()} />
        )} />
        <Route render={this.error}/>
      </Switch>
    );
  }

  private error = (_props: RouteComponentProps): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }

  // TODO: keeping for data alerts might need extra check here
  private protectedRouteForExtractRefreshSubspace(server: ServerService) {
    return server.isUserAuthorized(AuthLevel.SiteAdmin) &&
      <Route
        exact={true}
        path={this.props.urls.tasksExtractRefreshesPath()}
        render={this.props.provider('extractRefreshes', this.props)}
      />;
  }
}

export type SiteTasksSpaceComponentWithRouterProps = Omit<SiteTasksSpaceRouterProps, 'provider'>;
const provider = (subspaceName: SiteTasksSubspaceName, providerProps: SiteTasksSpaceComponentWithRouterProps): (props: SiteTasksRouteComponentProps) => JSX.Element => {
  return (props: SiteTasksRouteComponentProps): JSX.Element => {
    const spaceProps: SiteTasksSpaceProviderProps = {
      routeLocationSearch: props.location.search,
      routeLocationPath: props.location.pathname,
      subspaceName,
      urls: providerProps.urls,
      angularContext: providerProps.angularContext
    };
    return <SiteTasksSpaceProvider {...spaceProps} />;
  };
};

type SiteTasksSpaceComponentOwnProps = Omit<SiteTasksSpaceRouterOwnProps, 'provider'>;
const SiteTasksSpaceComponent = (props: SiteTasksSpaceComponentWithRouterProps) => {
  return (
    <SiteTasksSpaceRouterComponent {...props} provider={provider}/>
  );
};

export const SiteTasksSpaceRouter: React.FunctionComponent<SiteTasksSpaceComponentOwnProps> = SiteTasksSpaceComponent;
